import { ValidateAndSendCodeResponse } from "../stores/auth/interfaces/validate-and-send-code.response";
import axios from "axios";
import { environment } from "environments/environment";

export const codeService = {
    async send(phoneNumber: string): Promise<ValidateAndSendCodeResponse> {
        const response = await axios.post<ValidateAndSendCodeResponse>(environment.urls.validatePhone, { phoneNumber });
        return response.data;
    },

    async check(phoneNumber: string, code: string): Promise<ValidateAndSendCodeResponse> {
        const response = await axios.post<ValidateAndSendCodeResponse>(environment.urls.checkCode, { phoneNumber, code });
        return response.data;
    }
}